import { Create, Edit, List, SimpleForm, TextInput, Datagrid, TextField, required, CreateButton } from 'react-admin'
import CityIcon from '@mui/icons-material/LocationCity'
import { FC } from 'react'
import { CERTIFICATE_WRITE_SCOPE } from '../../config'
import { ConfirmDeleteToolbar, ListActionsToolbar, RestrictedButton } from '../../components'

const MunicipalityList: FC = () => (
  <List
    actions={
        <ListActionsToolbar i18n="resources.certificates.list">
          <RestrictedButton
            access={[CERTIFICATE_WRITE_SCOPE]}
            align="right"
          >
            {(): JSX.Element => <CreateButton variant="contained" />}
          </RestrictedButton>
        </ListActionsToolbar>
      }
    >
    <Datagrid rowClick="edit" bulkActionButtons={false} >
      <TextField source="organisatienNaam" label="resources.municipality.fields.organisatienaam" />
      <TextField source="plaatsNaam" label="resources.municipality.fields.plaatsnaam" />
      <TextField source="provincie" label="resources.municipality.fields.provincie" />

      <TextField source="contactNaam" label="resources.municipality.fields.contactpersoon" />
      <TextField source="contactTelefoon" label="data.phone" />
      <TextField source="contactEmail" label="data.email" />
    </Datagrid>
  </List>
)


const MunicipalityCreate: FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="organisatienNaam" label="resources.municipality.fields.organisatienaam" validate={[required()]} fullWidth />
      <TextInput source="plaatsNaam" label="resources.municipality.fields.plaatsnaam" validate={[required()]} fullWidth />
      <TextInput source="provincie" label="resources.municipality.fields.provincie" validate={[required()]} fullWidth />


      <TextInput source="contactNaam" label="resources.municipality.fields.contactpersoon" validate={[required()]} fullWidth />
      <TextInput source="contactTelefoon" label="data.phone" validate={[required()]} fullWidth />
      <TextInput source="contactEmail" type="email" label="data.email" validate={[required()]} fullWidth />
    </SimpleForm>
  </Create>
)


const MunicipalityEdit: FC = () => (
  <Edit>
    <SimpleForm toolbar={<ConfirmDeleteToolbar access={[CERTIFICATE_WRITE_SCOPE]} />} >
      <TextInput source="organisatienNaam" label="resources.municipality.fields.organisatienaam" validate={[required()]} fullWidth />
      <TextInput source="plaatsNaam" label="resources.municipality.fields.plaatsnaam" validate={[required()]} fullWidth />
      <TextInput source="provincie" label="resources.municipality.fields.provincie" validate={[required()]} fullWidth />

      <TextInput source="contactNaam" label="resources.municipality.fields.contactpersoon" validate={[required()]} fullWidth />
      <TextInput source="contactTelefoon" label="data.phone" validate={[required()]} fullWidth />
      <TextInput source="contactEmail" type="email" label="data.email" validate={[required()]} fullWidth />
    </SimpleForm>
  </Edit>
)


export default {
  list: MunicipalityList,
  create: MunicipalityCreate,
  edit: MunicipalityEdit,
  icon: CityIcon,
}